import Explainer from '../blocks';

import * as styles from './Streamline.module.css';

const Streamline = () => {
  return (
    <Explainer width={662} height={460} className={styles.root} once>
      <g transform="translate(15 73)">
        <g className={styles.container}>
          <g filter="url(#filter0_d_3496_11727)">
            <rect
              x="30"
              y="10"
              width="570"
              height="293"
              rx="10"
              fill="#031C2B"
            />
          </g>
          <text
            x="51"
            y="48"
            fontSize="13px"
            fontFamily="var(--font-family-mono)"
            letterSpacing="-0.006em"
            fill="#828D96"
          >
            $
          </text>
          <text
            x="51"
            y="134"
            fontSize="13px"
            fontFamily="var(--font-family-mono)"
            letterSpacing="-0.006em"
            fill="#828D96"
          >
            $
          </text>
          <text
            x="51"
            y="220"
            fontSize="13px"
            fontFamily="var(--font-family-mono)"
            letterSpacing="-0.006em"
            fill="#828D96"
          >
            $
          </text>
          <text
            x="67"
            y="48"
            fontSize="13px"
            fontFamily="var(--font-family-mono)"
            letterSpacing="-0.006em"
            fill="white"
          >
            docker login docker.cloudsmith.io
          </text>
          <text
            x="67"
            y="134"
            fontSize="13px"
            fontFamily="var(--font-family-mono)"
            letterSpacing="-0.006em"
            fill="white"
          >
            docker push docker.cloudsmith.io/org/registry/image:latest
          </text>
          <text
            x="67"
            y="220"
            fontSize="13px"
            fontFamily="var(--font-family-mono)"
            letterSpacing="-0.006em"
            fill="white"
          >
            docker pull docker.cloudsmith.io/org/registry/image:latest
          </text>
          <text
            x="68"
            y="74"
            fontSize="13px"
            fontFamily="var(--font-family-mono)"
            letterSpacing="-0.006em"
            fill="#C0C6CA"
          >
            Login Succeeded
          </text>
          <text
            x="68"
            y="160"
            fontSize="13px"
            fontFamily="var(--font-family-mono)"
            letterSpacing="-0.006em"
            fill="#C0C6CA"
          >
            Upload complete. Package will available following synchronisation.
          </text>
          <text
            x="68"
            y="246"
            fontSize="13px"
            fontFamily="var(--font-family-mono)"
            letterSpacing="-0.006em"
            fill="#C0C6CA"
          >
            latest: Pulling from org/registry/image
          </text>

          <path
            d="M53.2644 73.1708C53.2644 73.0769 53.2463 73.0299 53.2102 73.0299L52.9611 73.1491C52.9611 73.0985 52.9322 73.0624 52.8744 73.0408L52.7877 73.0299C52.73 73.0299 52.6577 73.0552 52.5711 73.1058C52.5566 73.0697 52.5386 73.0335 52.5169 72.9974C52.4952 72.9613 52.4772 72.9288 52.4627 72.8999C52.3688 72.7194 52.275 72.5208 52.1811 72.3041C52.0944 72.0802 52.0113 71.8672 51.9319 71.6649C51.8597 71.4627 51.8019 71.3038 51.7586 71.1883C51.7297 71.0944 51.6972 70.9535 51.6611 70.7658C51.625 70.578 51.5888 70.3397 51.5527 70.0508C51.6322 70.1013 51.6936 70.1266 51.7369 70.1266C51.7875 70.1266 51.8344 70.0508 51.8777 69.8991C51.8994 69.928 51.9391 69.9424 51.9969 69.9424C52.0402 69.9424 52.0727 69.928 52.0944 69.8991L52.2677 69.6391L52.4627 69.7041H52.4736C52.488 69.7041 52.5025 69.6969 52.5169 69.6824C52.5313 69.668 52.553 69.6535 52.5819 69.6391C52.6397 69.603 52.683 69.5849 52.7119 69.5849L52.7444 69.5958C52.925 69.6824 53.0405 69.8413 53.0911 70.0724C53.2211 70.6213 53.3511 70.8958 53.4811 70.8958C53.6111 70.8958 53.7627 70.7585 53.9361 70.4841C54.0227 70.3469 54.1094 70.188 54.1961 70.0074C54.29 69.8269 54.3838 69.6247 54.4777 69.4008C54.4922 69.4874 54.5066 69.5308 54.5211 69.5308C54.5572 69.5308 54.6186 69.4405 54.7052 69.2599C54.7991 69.0794 54.9472 68.8302 55.1494 68.5124C55.265 68.3174 55.4094 68.0972 55.5827 67.8516C55.7633 67.606 55.9547 67.3533 56.1569 67.0933C56.3591 66.8333 56.5541 66.5877 56.7419 66.3566C56.9369 66.1255 57.1102 65.9269 57.2619 65.7608C57.4136 65.5947 57.5255 65.4863 57.5977 65.4358C57.8722 65.248 58.0888 65.0674 58.2477 64.8941C58.2405 64.9447 58.2297 64.9916 58.2152 65.0349C58.208 65.071 58.2044 65.0963 58.2044 65.1108C58.2044 65.1397 58.2188 65.1541 58.2477 65.1541L58.5511 65.0024V65.0458C58.5511 65.1035 58.5655 65.1324 58.5944 65.1324C58.6161 65.1324 58.6594 65.0999 58.7244 65.0349C58.7894 64.9699 58.8255 64.923 58.8327 64.8941L58.8111 65.0458L59.1794 64.8291L59.0927 65.0241C59.2083 64.9447 59.2913 64.9049 59.3419 64.9049C59.3708 64.9049 59.3925 64.923 59.4069 64.9591C59.4213 64.988 59.4286 65.0169 59.4286 65.0458C59.4286 65.0891 59.4105 65.1397 59.3744 65.1974C59.3383 65.2552 59.2913 65.3238 59.2336 65.4033C59.1902 65.461 59.118 65.5477 59.0169 65.6633C58.923 65.7716 58.7786 65.9341 58.5836 66.1508C58.3886 66.3602 58.1286 66.6527 57.8036 67.0283C57.7169 67.1222 57.5833 67.2883 57.4027 67.5266C57.2222 67.7577 57.0163 68.0285 56.7852 68.3391C56.5613 68.6424 56.3375 68.9494 56.1136 69.2599C55.8897 69.5705 55.6911 69.8522 55.5177 70.1049C55.3444 70.3505 55.2216 70.5347 55.1494 70.6574L54.4777 71.7949C54.3333 72.0405 54.2141 72.2427 54.1202 72.4016C54.0263 72.5533 53.9541 72.658 53.9036 72.7158C53.7952 72.8458 53.6761 72.9613 53.5461 73.0624L53.4486 73.0083L53.3619 73.0624L53.2644 73.1708Z"
            fill="#2A6FE1"
          />

          <line x1="30" y1="108.5" x2="600" y2="108.5" stroke="#364A56" />
          <line x1="30" y1="194.5" x2="600" y2="194.5" stroke="#364A56" />
          <line x1="30" y1="280.5" x2="600" y2="280.5" stroke="#364A56" />
          <path
            d="M53.2644 159.171C53.2644 159.077 53.2463 159.03 53.2102 159.03L52.9611 159.149C52.9611 159.099 52.9322 159.062 52.8744 159.041L52.7877 159.03C52.73 159.03 52.6577 159.055 52.5711 159.106C52.5566 159.07 52.5386 159.034 52.5169 158.997C52.4952 158.961 52.4772 158.929 52.4627 158.9C52.3688 158.719 52.275 158.521 52.1811 158.304C52.0944 158.08 52.0113 157.867 51.9319 157.665C51.8597 157.463 51.8019 157.304 51.7586 157.188C51.7297 157.094 51.6972 156.954 51.6611 156.766C51.625 156.578 51.5888 156.34 51.5527 156.051C51.6322 156.101 51.6936 156.127 51.7369 156.127C51.7875 156.127 51.8344 156.051 51.8777 155.899C51.8994 155.928 51.9391 155.942 51.9969 155.942C52.0402 155.942 52.0727 155.928 52.0944 155.899L52.2677 155.639L52.4627 155.704H52.4736C52.488 155.704 52.5025 155.697 52.5169 155.682C52.5313 155.668 52.553 155.654 52.5819 155.639C52.6397 155.603 52.683 155.585 52.7119 155.585L52.7444 155.596C52.925 155.682 53.0405 155.841 53.0911 156.072C53.2211 156.621 53.3511 156.896 53.4811 156.896C53.6111 156.896 53.7627 156.759 53.9361 156.484C54.0227 156.347 54.1094 156.188 54.1961 156.007C54.29 155.827 54.3838 155.625 54.4777 155.401C54.4922 155.487 54.5066 155.531 54.5211 155.531C54.5572 155.531 54.6186 155.44 54.7052 155.26C54.7991 155.079 54.9472 154.83 55.1494 154.512C55.265 154.317 55.4094 154.097 55.5827 153.852C55.7633 153.606 55.9547 153.353 56.1569 153.093C56.3591 152.833 56.5541 152.588 56.7419 152.357C56.9369 152.125 57.1102 151.927 57.2619 151.761C57.4136 151.595 57.5255 151.486 57.5977 151.436C57.8722 151.248 58.0888 151.067 58.2477 150.894C58.2405 150.945 58.2297 150.992 58.2152 151.035C58.208 151.071 58.2044 151.096 58.2044 151.111C58.2044 151.14 58.2188 151.154 58.2477 151.154L58.5511 151.002V151.046C58.5511 151.104 58.5655 151.132 58.5944 151.132C58.6161 151.132 58.6594 151.1 58.7244 151.035C58.7894 150.97 58.8255 150.923 58.8327 150.894L58.8111 151.046L59.1794 150.829L59.0927 151.024C59.2083 150.945 59.2913 150.905 59.3419 150.905C59.3708 150.905 59.3925 150.923 59.4069 150.959C59.4213 150.988 59.4286 151.017 59.4286 151.046C59.4286 151.089 59.4105 151.14 59.3744 151.197C59.3383 151.255 59.2913 151.324 59.2336 151.403C59.1902 151.461 59.118 151.548 59.0169 151.663C58.923 151.772 58.7786 151.934 58.5836 152.151C58.3886 152.36 58.1286 152.653 57.8036 153.028C57.7169 153.122 57.5833 153.288 57.4027 153.527C57.2222 153.758 57.0163 154.029 56.7852 154.339C56.5613 154.642 56.3375 154.949 56.1136 155.26C55.8897 155.57 55.6911 155.852 55.5177 156.105C55.3444 156.35 55.2216 156.535 55.1494 156.657L54.4777 157.795C54.3333 158.04 54.2141 158.243 54.1202 158.402C54.0263 158.553 53.9541 158.658 53.9036 158.716C53.7952 158.846 53.6761 158.961 53.5461 159.062L53.4486 159.008L53.3619 159.062L53.2644 159.171Z"
            fill="#2A6FE1"
          />
          <path
            d="M53.2644 245.171C53.2644 245.077 53.2463 245.03 53.2102 245.03L52.9611 245.149C52.9611 245.099 52.9322 245.062 52.8744 245.041L52.7877 245.03C52.73 245.03 52.6577 245.055 52.5711 245.106C52.5566 245.07 52.5386 245.034 52.5169 244.997C52.4952 244.961 52.4772 244.929 52.4627 244.9C52.3688 244.719 52.275 244.521 52.1811 244.304C52.0944 244.08 52.0113 243.867 51.9319 243.665C51.8597 243.463 51.8019 243.304 51.7586 243.188C51.7297 243.094 51.6972 242.954 51.6611 242.766C51.625 242.578 51.5888 242.34 51.5527 242.051C51.6322 242.101 51.6936 242.127 51.7369 242.127C51.7875 242.127 51.8344 242.051 51.8777 241.899C51.8994 241.928 51.9391 241.942 51.9969 241.942C52.0402 241.942 52.0727 241.928 52.0944 241.899L52.2677 241.639L52.4627 241.704H52.4736C52.488 241.704 52.5025 241.697 52.5169 241.682C52.5313 241.668 52.553 241.654 52.5819 241.639C52.6397 241.603 52.683 241.585 52.7119 241.585L52.7444 241.596C52.925 241.682 53.0405 241.841 53.0911 242.072C53.2211 242.621 53.3511 242.896 53.4811 242.896C53.6111 242.896 53.7627 242.759 53.9361 242.484C54.0227 242.347 54.1094 242.188 54.1961 242.007C54.29 241.827 54.3838 241.625 54.4777 241.401C54.4922 241.487 54.5066 241.531 54.5211 241.531C54.5572 241.531 54.6186 241.44 54.7052 241.26C54.7991 241.079 54.9472 240.83 55.1494 240.512C55.265 240.317 55.4094 240.097 55.5827 239.852C55.7633 239.606 55.9547 239.353 56.1569 239.093C56.3591 238.833 56.5541 238.588 56.7419 238.357C56.9369 238.125 57.1102 237.927 57.2619 237.761C57.4136 237.595 57.5255 237.486 57.5977 237.436C57.8722 237.248 58.0888 237.067 58.2477 236.894C58.2405 236.945 58.2297 236.992 58.2152 237.035C58.208 237.071 58.2044 237.096 58.2044 237.111C58.2044 237.14 58.2188 237.154 58.2477 237.154L58.5511 237.002V237.046C58.5511 237.104 58.5655 237.132 58.5944 237.132C58.6161 237.132 58.6594 237.1 58.7244 237.035C58.7894 236.97 58.8255 236.923 58.8327 236.894L58.8111 237.046L59.1794 236.829L59.0927 237.024C59.2083 236.945 59.2913 236.905 59.3419 236.905C59.3708 236.905 59.3925 236.923 59.4069 236.959C59.4213 236.988 59.4286 237.017 59.4286 237.046C59.4286 237.089 59.4105 237.14 59.3744 237.197C59.3383 237.255 59.2913 237.324 59.2336 237.403C59.1902 237.461 59.118 237.548 59.0169 237.663C58.923 237.772 58.7786 237.934 58.5836 238.151C58.3886 238.36 58.1286 238.653 57.8036 239.028C57.7169 239.122 57.5833 239.288 57.4027 239.527C57.2222 239.758 57.0163 240.029 56.7852 240.339C56.5613 240.642 56.3375 240.949 56.1136 241.26C55.8897 241.57 55.6911 241.852 55.5177 242.105C55.3444 242.35 55.2216 242.535 55.1494 242.657L54.4777 243.795C54.3333 244.04 54.2141 244.243 54.1202 244.402C54.0263 244.553 53.9541 244.658 53.9036 244.716C53.7952 244.846 53.6761 244.961 53.5461 245.062L53.4486 245.008L53.3619 245.062L53.2644 245.171Z"
            fill="#2A6FE1"
          />
        </g>

        <defs>
          <filter
            id="filter0_d_3496_11727"
            x="0"
            y="0"
            width="630"
            height="353"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="20" />
            <feGaussianBlur stdDeviation="15" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.286275 0 0 0 0 0.541176 0 0 0 0 0.964706 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_3496_11727"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_3496_11727"
              result="shape"
            />
          </filter>
        </defs>
      </g>
    </Explainer>
  );
};

export default Streamline;
